import { NotificationData } from './data';
import { alertRulesFromJson } from '../alerts/rules/mapper';
import { alertDataFromJson } from '../alerts/mapper';

export function mapNotificationData(notification) {
    return new NotificationData({
        id: notification.id,
        isRead: notification.isRead,
        checkDate: new Date(notification.checkDate),
        vesselName: notification.vesselName,
        alertRule: alertRulesFromJson(notification.alertRule),
        alertToBeExecuted: alertDataFromJson(notification.alertToBeExecuted)
    });
}
